import { useEffect, useState } from 'react';
import { BeatLoader } from 'react-spinners';
import { getSellDomainList } from 'store/actions/sell.action';
import { ReactPagination } from 'views/components/CommonPages';

interface sellDomainData {
  UID: string;
  domainName: string;
  minQuote: number;
  price: number;
  premium: number;
  name: string;
  email: string;
  phone: string;
}

interface domainData {
  data: sellDomainData[];
  total: number;
  totalPage: number;
}
let searchFilter;

const SellDomainDashboard = () => {
  const [fetchingData, setFetchingData] = useState(false);
  const [sellDomainData, setSellDomainData] = useState<domainData>({ data: [], total: 0, totalPage: 0 });
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (searchFilter) clearTimeout(searchFilter);
    const query = new URLSearchParams({ page: String(page), search });
    const queryString = query.toString();
    searchFilter = setTimeout(() => {
      setFetchingData(true);
      getSellDomainList(`?${queryString}`).then((data) => {
        if (data) setSellDomainData(data);
        setFetchingData(false);
      });
    }, 500);
    return () => {
      if (searchFilter) clearTimeout(searchFilter);
    };
  }, [page, search]);

  return (
    <div className="mt-2 mb-4 overflow-x-auto">
      <input
        type="text"
        className="form-control admin-search mt-4"
        id="search"
        name="search"
        value={search}
        onChange={(e) => {
          const value = e.target.value;
          setSearch(value);
          setPage(1);
        }}
        placeholder="search by domain / email / name"
      />

      <div className="table-responsive mt-4">
        <table className="table text-center table table-striped table-hover">
          <thead>
            <tr className="">
              <th scope="col" className="text-nowrap">
                Name
              </th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Domain</th>
              <th scope="col">Price</th>
              <th scope="col">Minimum Quote</th>
            </tr>
          </thead>
          <tbody>
            {fetchingData ? (
              <tr>
                <td colSpan={10} className="text-center table-loader">
                  <BeatLoader color="#ff7728" />
                </td>
              </tr>
            ) : !sellDomainData.data || sellDomainData.data.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center">
                  No Record found
                </td>
              </tr>
            ) : Array.isArray(sellDomainData.data) ? (
              <>
                {sellDomainData.data.map((data: sellDomainData) => (
                  <tr key={data.UID}>
                    <td className="text-nowrap">{data.name}</td>
                    <td className="text-nowrap">{data.email}</td>
                    <td className="text-nowrap">{data.phone}</td>
                    <td>
                      <div>{data.domainName}</div>
                      {Boolean(data.premium) && (
                        <div className="font-weight-bold" style={{ fontSize: '10px', textTransform: 'uppercase' }}>
                          premium
                        </div>
                      )}
                    </td>
                    <td>{data.price}</td>
                    <td>{data.minQuote}</td>
                  </tr>
                ))}
              </>
            ) : null}
          </tbody>
        </table>
      </div>

      <ReactPagination currentPage={page} totalPages={sellDomainData.totalPage} onPageChange={(v) => setPage(v)} />
    </div>
  );
};

export default SellDomainDashboard;
